import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import api from "@/modules/shared/api/axios";
import { setFeatureFlags } from "./featureFlags";

// Platform feature switches from the backend, e.g. { branches: true }.
// A feature counts as enabled until the backend explicitly says `false`, so
// older backends and failed requests leave everything on.
export const fetchFeatures = createAsyncThunk(
  "features/fetchFeatures",
  async () => {
    // Short timeout: the first render waits for this, and a failure just leaves everything on.
    const res = await api.get("/features", { timeout: 5000 });
    const data = res?.data?.data;
    return data && typeof data === "object" ? data : {};
  }
);

const featuresSlice = createSlice({
  name: "features",
  // `loaded` lets the app hold its first render until the switches are known (or failed).
  initialState: { flags: {}, loaded: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeatures.fulfilled, (state, action) => {
        state.flags = action.payload;
        state.loaded = true;
        setFeatureFlags(action.payload);
      })
      .addCase(fetchFeatures.rejected, (state) => {
        state.loaded = true;
      });
  },
});

export const selectFeature = (state, key) => state.features.flags[key] !== false;

export const useFeature = (key) => useSelector((state) => selectFeature(state, key));

export default featuresSlice.reducer;
